import api from 'app/api'
import axios from 'axios'

export const signIn = body =>
  axios.post(api`/v1/auth`, body).then(({ data }) => data)
